var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('h2', {
    staticClass: "tit--lg line-height-1 color-white",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.visual))])])]), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "pl-36"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sub/visual/sv-icon.png",
      "max-width": "360"
    }
  })], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }